import Device		from "../device.js";
import { tmc5041 }	from "./tmc5051.so";

export default class TMC5041 extends Device {
  constructor() { 
    super();
    
    this.id = "-";
    this.status = "-";       

    this.serialNumber = "-";
    this.value = "-";
  }
  async initialize() {
    try {            
      tmc5041.openSync();
      this.name = "aqex_tmc5041"
      this.status = "OK";

    } catch(e) {
      this.status = `Failed: ${e}`;
      throw e;
    }
  }
  setVelocitySync(motorid, value) {
    tmc5041.setVelocitySync(motorid, value);
  }  
  async update() {
    try {                          
      this.status = "Ok";
    } catch(e) {
      this.value = "-";
      this.status = `Failed: ${e}`;
      throw e;
    }      
  }
  get type() {
    return "bus";
  }  
  toJSON() {
    return({
      name: this.name,            
      usbProductName: this.usbProductName,
      usbSerialNumber: this.usbSerialNumber,
      status: this.status,      
      id: this.id,
      type: this.type,
      serialNumber: this.serialNumber,
      value: this.value,
      class: this.class
    });
  }
}